import type { ReactNode } from "react";
import { BrandMark } from "@/components/layout/brand-mark";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { Button } from "@/components/ui/button";
import { OnboardingStepper } from "../onboarding-stepper";

const WIZARD_STEPS = ["Perfil", "Modelo", "Cadastro", "Equipe", "Revisão"];

interface OnboardingShellProps {
	currentStep: number;
	onExit: () => void;
	children: ReactNode;
}

export function OnboardingShell({
	currentStep,
	onExit,
	children,
}: OnboardingShellProps) {
	return (
		<div className="onboarding-shell">
			<header className="onboarding-shell__header">
				<BrandMark />
				<div className="onboarding-shell__actions">
					<ThemeToggle />
					<Button variant="ghost" size="sm" onClick={onExit}>
						Sair
					</Button>
				</div>
			</header>
			<main className="onboarding-shell__main">
				<OnboardingStepper steps={WIZARD_STEPS} current={currentStep} />
				{children}
			</main>
		</div>
	);
}
